/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import IngresoPdf from "../../Modulo_formularios/Componentes/IngresoPdf";
import {useResponsive} from "../../Modulo_Responsive/Hooks/useResponsive";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import {Flag} from '@mui/icons-material'


const Formulario_Configuraciones = ({...props}) => {
    const {sCell} = useResponsive()

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
                sx={{overflowX: 'hidden'}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Guia de tallas general</Typography>
                </Grid>


                <Grid container size={{xs: 12, sm: 6, md: 6}}>
                    <IngresoPdf
                        dato={'guia_tallas'} {...props}
                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>

                    <IngresoSelect Icono={Flag} nombre={'Banner Black Friday'} dato={'black'}  {...props}
                                   opciones={['Si', 'No']}
                    />

                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 3}} sx={{justifyContent: 'flex-start'}}>
                    <IngresoSelect Icono={Flag} nombre={'Banner Primera Compra'} dato={'primera'}  {...props}
                                   opciones={['Si', 'No']}
                    />
                </Grid>




                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 2, mb: 8}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>

                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                <Typography>Imagen Categoria Superior (Max 300Kb)</Typography>
                            </Grid>
                            <IngresoImagenCrop dato={'imgSuperior'} alto={1} ancho={1} {...props} />
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                <Typography>Imagen Categoria Inferior (Max 300Kb)</Typography>
                            </Grid>
                            <IngresoImagenCrop dato={'imgInferior'} alto={1} ancho={1} {...props} />
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 4}} sx={{justifyContent: 'flex-start'}}>
                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                                <Typography>Imagen Categoria Accesorios (Max 300Kb)</Typography>
                            </Grid>
                            <IngresoImagenCrop dato={'imgAccesorios'} alto={1} ancho={1} {...props} />
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>

        </form>

    )

}
export default Formulario_Configuraciones